import { render, staticRenderFns } from "./temporary_residence_calculator.vue?vue&type=template&id=0f03ba00&"
import script from "./temporary_residence_calculator.vue?vue&type=script&lang=js&"
export * from "./temporary_residence_calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports